import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type {
  IAtencionMeta,
  IAtencionesMetaParams,
  ICumplimientoParams,
  ICumplimientoResponse,
  IConfCupsMetas,
  IOportunidadesFiltros,
  IOportunidadesFiltrosParams,
  IOportunidadesParams,
  IOportunidadesResponse,
  ItiposCupsMetas
} from '@/modules/Contratacion/interfaces'

export class MetasService extends BaseService<IConfCupsMetas> {
  constructor() {
    super({
      baseUrl: 'system/cups-metas/'
    })
  }

  async searchByContrato(
    cocoId: number,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfCupsMetas[]>>> {
    return this.http.get<IResponseApi<IConfCupsMetas[]>>(`/by-contrato/${cocoId}`, {
      params
    })
  }

  async getGenerales(): Promise<AxiosResponse<IResponseApi<ItiposCupsMetas>>> {
    return this.http.get<IResponseApi<ItiposCupsMetas>>(`/general`)
  }

  // Nuevas funciones
  async createMulti(
    data: IConfCupsMetas[]
  ): Promise<AxiosResponse<IResponseApi<IConfCupsMetas[]>>> {
    return this.http.post<IResponseApi<IConfCupsMetas[]>>(`/create-multi`, data)
  }

  async updateMulti(
    data: IConfCupsMetas[]
  ): Promise<AxiosResponse<IResponseApi<IConfCupsMetas[]>>> {
    return this.http.put<IResponseApi<IConfCupsMetas[]>>(`/update-multi`, data)
  }

  async getCumplimiento(
    params: ICumplimientoParams
  ): Promise<AxiosResponse<IResponseApi<ICumplimientoResponse>>> {
    return this.http
      .get<IResponseApi<ICumplimientoResponse>>(`/cumplimiento`, { params })
      .catch(this.errorHandle)
  }

  async getAtencionesMeta(
    params: IAtencionesMetaParams
  ): Promise<AxiosResponse<IResponseApi<IAtencionMeta[]>>> {
    return this.http
      .get<IResponseApi<IAtencionMeta[]>>(`/cumplimiento/atenciones`, { params })
      .catch(this.errorHandle)
  }

  async getOportunidades(
    params: IOportunidadesParams
  ): Promise<AxiosResponse<IResponseApi<IOportunidadesResponse>>> {
    return this.http
      .get<IResponseApi<IOportunidadesResponse>>(`/oportunidades`, { params })
      .catch(this.errorHandle)
  }

  async getOportunidadesFiltros(
    params?: IOportunidadesFiltrosParams
  ): Promise<AxiosResponse<IResponseApi<IOportunidadesFiltros>>> {
    return this.http
      .get<IResponseApi<IOportunidadesFiltros>>(`/oportunidades/filtros`, { params })
      .catch(this.errorHandle)
  }
}

export default new MetasService()
